const specialAccounts = ['jpowsd085119'];

export function isSpecialAccount(account: string) {
  if (specialAccounts.includes(account)) {
    return true;
  }
  return false;
}
